<template>
  <div
    class="product"
    :class="{ selected: group.productTypeName === selectedProductGroup }"
    @click="_click(group.productTypeName)"
  >
    <div>
      <img class="ico_product" :src="require(`@/assets/img/scmp/productType/${group.imgName}`)" />
      {{ group.productTypeName }}
    </div>
    <div>{{ group.count }}</div>
  </div>
</template>

<script>
export default {
  props: {
    group: {
      type: Object,
      default: () => ({})
    },
    selectedProductGroup: {
      type: String,
      default: ''
    }
  },
  methods: {
    _click(groupName) {
      this.$emit('change-group', groupName);
    }
  }
};
</script>

<style lang="scss" scoped>
.product {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 32px;
  padding: 8px 12px;
  cursor: pointer;
  user-select: none;

  > div {
    font-family: $lego__font-family;
    font-size: 13px;
    font-style: normal;

    line-height: 16px;
    color: var(--dark);

    &:nth-child(1) {
      display: flex;
      align-items: center;
      font-weight: 400;
    }

    &:nth-child(2) {
      font-weight: 500;
    }
  }

  &.selected {
    background-color: #e1e7f9;
    border-radius: 4px;
  }

  &:not(.selected):hover {
    background: rgb(239, 241, 251);
    border-radius: 4px;
  }

  .ico_product {
    width: 16px;
    height: 16px;
    margin: 0 8px 0 0;
    object-fit: contain;
  }

  &:nth-child(n + 2) {
    margin-top: 6px;
  }
}
</style>
